// i18n
import './locales/i18n';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
// routes
import { LicenseInfo } from '@mui/x-license-pro';
import Router from './routes';
// theme
import ThemeProvider from './theme';
// locales
import ThemeLocalization from './locales';
// components
import SnackbarProvider from './components/snackbar';
import { ThemeSettings, SettingsProvider } from './components/settings';
import { MotionLazyContainer } from './components/animate';
import ScrollToTop from './components/scroll-to-top';

// Check our docs
// https://docs.minimals.cc/authentication/js-version

import { AuthProvider } from './auth/JwtContext';

// ----------------------------------------------------------------------
LicenseInfo.setLicenseKey(
  '27c495e67f4950c3d812be544d2aded4Tz02MzYxNyxFPTE3MTIyNTAzNjQ2MjQsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y'
);
export default function App() {
  useEffect(() => {
    ReactGA.initialize('G-0QCN0LED3Q');
    ReactGA.send('pageview', { page: window.location.pathname });

    // Track JPG file downloads
const handleClick = (e) => {
  const link = e.target.closest('a');
  if (link && link.href && link.href.includes('backend.teamavalonpontoons.com')) {
    ReactGA.event('file_download', {
      file_name: link.href.split('/').pop(),
      file_extension: link.href.split('.').pop(),
      file_path: link.href
    });
  }
};

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <AuthProvider>
      <HelmetProvider>
        <SettingsProvider>
          <BrowserRouter>
            <ScrollToTop />
            <MotionLazyContainer>
              <ThemeProvider>
                <ThemeSettings>
                  <ThemeLocalization>
                    <SnackbarProvider>
                      <Router />
                    </SnackbarProvider>
                  </ThemeLocalization>
                </ThemeSettings>
              </ThemeProvider>
            </MotionLazyContainer>
          </BrowserRouter>
        </SettingsProvider>
      </HelmetProvider>
    </AuthProvider>
  );
}
